export const compareTwoDate = (dateA: Date, dateB:Date) => {
	return dateA.getTime() - dateB.getTime();
};
